/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type QueueMessageStatusEnum = 'QUEUED' | 'DEQUEUED';

export const QueueMessageStatusEnum = {

    QUEUED: 'QUEUED' as QueueMessageStatusEnum,

    DEQUEUED: 'DEQUEUED' as QueueMessageStatusEnum
};

